module.exports = __webpack_public_path__ + "assets/nvd3.6a462acb.svg";